import { Check, History } from 'lucide-react';

export function Pricing() {
  const plans = [
    {
      name: 'Basic',
      price: '150€',
      byUser: '15€',
      description: 'Idéal pour débuter en toute simplicité',
      features: [
        '10 Utilisateurs',
        'Arborescence des pages modulable',
        'Formulaires personnalisables',
        'Importation de documents',
        'Autocomplétion des adresses',
        'Gestion des utilisateurs et des rôles',
        'Historique des modifications',
      ],
    },
    {
      name: 'Pro light',
      price: '225',
      byUser: '15€',
      description: 'Conçu pour les petites équipes',
      features: [
        'Toutes les fonctionnalités du <b><i>Basic</i></b>',
        '15 Utilisateurs',
        'Accès au planning partagé',
        'Calcul d’itinéraires',
        'Historique des rendez-vous',
        'Notifications en temps réel',
      ],
    },
    {
      name: 'Pro',
      price: '300',
      byUser: '12€',
      description: 'Conçu pour les équipes en croissance',
      features: [
        'Toutes les fonctionnalités du <b><i>Pro light</i></b>',
        '25 Utilisateurs',
        'Automatisation des actions',
        'Génération de documents PDF',
        'Signature électronique',
        'Support prioritaire',
      ],
      idxSoon: [3, 4],
      popular: true,
    },
    {
      name: 'Entreprise',
      price: '375€',
      byUser: '',
      description: 'Adapté aux grandes structures',
      features: [
        'Toutes les fonctionnalités du <b><i>Pro</i></b>',
        'Utilisateurs illimités',
        'Accès exclusif aux fonctionnalités à venir',
        'Support prioritaire',
      ],
    },
  ];

  return (
    <section id='pricing' className='py-20 bg-gray-50'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='text-center mb-16'>
          <h2 className='text-4xl font-bold text-gray-900 mb-4'>
            Des tarifs adaptés à vos besoins
          </h2>
          <p className='text-xl text-gray-600'>
            Choisissez le plan qui correspond le mieux à votre activité
          </p>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-4 gap-8'>
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl shadow-lg p-5 ${
                plan.popular
                  ? 'ring-2 ring-blue-600 scale-105 bg-gradient-to-b from-blue-200 to-white'
                  : 'bg-gradient-to-b from-blue-50 to-white'
              }`}
            >
              {plan.popular && (
                <span className='bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium'>
                  Populaire
                </span>
              )}
              <h3 className='text-2xl font-bold mt-4'>{plan.name}</h3>
              <div className='mt-4'>
                <span className='text-4xl font-bold'>{plan.price}</span>
                <span className='text-gray-600'> HT /mois</span>
              </div>
              <p className='mt-2 text-gray-600'>{plan.description}</p>
              {plan.byUser && (
                <div className='inline-block bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 mt-4'>
                  <p className='text-xs text-gray-600'>
                    {plan.byUser} / utilisateur{' '}
                  </p>
                </div>
              )}

              <ul className='mt-8 space-y-4'>
                {plan.features.map((feature, idx) => (
                  <li key={idx} className=' items-center relative'>
                    <div className='flex items-center'>
                      <Check
                        className='text-blue-600 mr-3'
                        style={{ minWidth: '23px', maxWidth: '23px' }}
                      />
                      <span dangerouslySetInnerHTML={{ __html: feature }} />
                    </div>
                    {plan.idxSoon?.includes(idx) && (
                      <span
                        className='coming-soon-badge'
                        style={{ left: 20, top: 50, marginLeft: 30 }}
                      >
                        <History className='text-white' size={10} />
                        Prochainement
                      </span>
                    )}
                  </li>
                ))}
              </ul>

              {/* <button className={`w-full mt-8 px-6 py-3 rounded-full ${
                plan.popular
                  ? 'bg-blue-600 text-white hover:bg-blue-700'
                  : 'border-2 border-blue-600 text-blue-600 hover:bg-blue-50'
              } transition-colors`}>
                Commencer
              </button> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
